<template>
  <div id="inspire">
    <div>
      <v-layout class="justify-center" justify-center>
        <v-card outlined class="elevation-1" width="700px">
          <v-card-title class="justify-center">
            <img class="img-responsive" :src="logotipo" style="width: 90%; text-align: center" />
            <v-alert :value="true" v-if="!logotipo" color="error" icon="check_circle" outlined>Módulo do Assinante indisponível no momento!</v-alert>
          </v-card-title>
          <v-card-text>
            <v-tabs v-if="logotipo" v-model="tab" center-active show-arrows>
              <v-tab><span style="font-size: 10px">Já possuo cadastro</span></v-tab>
              <v-tab v-if="$store.state.site.assinante"><span style="font-size: 10px">Novo usuário</span></v-tab>
              <v-tab><span style="font-size: 10px">Recuperar senha</span></v-tab>
              <v-tab v-if="abaAlterar"><span style="font-size: 10px">Alterar meu e-mail</span></v-tab>
              <v-tab><span style="font-size: 10px" @click="assine">Assine</span></v-tab>
            </v-tabs>

            <v-tabs-items v-if="logotipo" v-model="tab">
              <v-tab-item>
                <v-form ref="formEntrar" v-model="entrarValid" lazy-validation class="mt-4">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field
                          autofocus
                          :disabled="isUpdating"
                          background-color="white"
                          v-model="usuario.login"
                          maxlength="100"
                          label="Entre com seu E-mail ou CPF/CNPJ"
                          hint="Obrigatório"
                          :rules="[validacao.login == false || validacao.login, (value) => !!value || 'Obrigatório.', (value) => valida_email_identificacao(value)]"
                          autocomplete="disabled"
                          :name="Math.random()"
                          @change="validacao.login = false"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          :disabled="isUpdating"
                          background-color="white"
                          v-model="usuario.senha"
                          label="Senha"
                          maxlength="20"
                          :type="showSenha ? 'text' : 'password'"
                          :append-icon="showSenha ? 'visibility' : 'visibility_off'"
                          @click:append="showSenha = !showSenha"
                          hint="Obrigatório"
                          :rules="[validacao.senha == false || validacao.senha, (value) => !!value || 'Obrigatório.']"
                          autocomplete="disabled"
                          :name="Math.random()"
                          @change="validacao.senha = false"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 v-if="$route.query.promo">
                        <v-text-field
                          :disabled="isUpdating"
                          background-color="white"
                          v-model="usuario.promocional"
                          maxlength="25"
                          label="Código Promocional"
                          :rules="[validacao.promocional == false || validacao.promocional]"
                          autocomplete="disabled"
                          :name="Math.random()"
                          @change="validacao.promocional = false"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-sheet class="ml-1 red--text" :value="true" v-if="validacao.mensagemErro">{{ validacao.mensagemErro }}</v-sheet>
                      </v-flex>
                      <v-flex xs12 v-if="recSenha">
                        <a href="#" @click="tab = 2">Esqueci minha senha</a>
                      </v-flex>
                      <v-flex xs12 class="text-center">
                        <v-btn :disabled="isUpdating" class="primary" large @click="entrar">Entrar</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-tab-item>

              <v-tab-item v-if="$store.state.site.assinante">
                <v-form ref="formNovo" v-model="novoValid" lazy-validation class="mt-4">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field
                          autofocus
                          :disabled="isUpdating"
                          background-color="white"
                          v-model="usuario.identificacao"
                          maxlength="14"
                          v-mask="'##############'"
                          label="CPF/CNPJ"
                          hint="Obrigatório"
                          :rules="[validacao.identificacao == false || validacao.identificacao, (value) => !!value || 'Obrigatório.', (value) => valida_identificacao(value)]"
                          autocomplete="disabled"
                          :name="Math.random()"
                          @change="validacao.identificacao = false"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          :disabled="isUpdating"
                          background-color="white"
                          v-model="usuario.email"
                          maxlength="100"
                          label="E-mail"
                          hint="Obrigatório"
                          :rules="[validacao.email == false || validacao.email, (value) => !!value || 'Obrigatório.', (value) => valida_email(value)]"
                          autocomplete="disabled"
                          :name="Math.random()"
                          @change="validacao.email = false"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          :disabled="isUpdating"
                          background-color="white"
                          v-model="usuario.nome"
                          maxlength="100"
                          label="Nome Completo"
                          hint="Obrigatório"
                          :rules="[validacao.nome == false || validacao.nome, (value) => !!value || 'Obrigatório.', (value) => value.length > 2 || 'Obrigatório.']"
                          autocomplete="disabled"
                          :name="Math.random()"
                          @change="
                            usuario.nome = pLetra(usuario.nome);
                            validacao.nome = false;
                          "
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6 v-if="usuario.identificacao.length != 14">
                        <v-text-field
                          :disabled="isUpdating"
                          v-model="dtNascimento"
                          label="Data de Nascimento"
                          v-mask="'##/##/####'"
                          :rules="[validacao.dtNascimento == false || validacao.dtNascimento, (value) => valida_data_nasc(value)]"
                          color="blue-grey lighten-2"
                          autocomplete="disabled"
                          :name="Math.random()"
                          @change="validacao.dtNascimento = false"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6 v-if="usuario.identificacao.length != 14">
                        <v-autocomplete
                          :disabled="isUpdating"
                          v-model="usuario.sexo"
                          :items="sexos"
                          :filter="filtrarObjetos"
                          hint="Obrigatório"
                          :rules="[validacao.sexo == false || validacao.sexo, (value) => value != null || 'Obrigatório']"
                          label="Sexo"
                          item-text="nome"
                          item-value="id"
                          autocomplete="disabled"
                          :name="Math.random()"
                          no-data-text
                          @change="validacao.sexo = false"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs6>
                        <v-autocomplete
                          :disabled="isUpdating"
                          v-model="tipoFone"
                          :items="tiposFone"
                          :filter="filtrarObjetos"
                          hint="Obrigatório"
                          :rules="[validacao.tipoFone == false || validacao.tipoFone, (value) => value != null || 'Obrigatório']"
                          label="Telefone"
                          item-text="nome"
                          item-value="id"
                          autocomplete="disabled"
                          :name="Math.random()"
                          no-data-text
                          @change="validacao.tipoFone = false"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs2>
                        <v-text-field
                          :disabled="isUpdating"
                          v-model="usuario.ddd"
                          label="DDD"
                          v-mask="'##'"
                          hint="Obrigatório"
                          :rules="[validacao.ddd == false || validacao.ddd, (value) => !!value || 'Obrigatório.', (value) => valida_ddd(value)]"
                          color="blue-grey lighten-2"
                          @change="validacao.ddd = false"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          :disabled="isUpdating"
                          v-model="usuario.numero"
                          label="Número"
                          v-mask="'###########'"
                          hint="Obrigatório"
                          :rules="[
                            validacao.numero == false || validacao.numero,
                            (value) => !!value || 'Obrigatório.',
                            (value) => (value != null && value.length > 7) || 'Número inválido'
                          ]"
                          color="blue-grey lighten-2"
                          autocomplete="disabled"
                          :name="Math.random()"
                          @change="validacao.numero = false"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field
                          :disabled="isUpdating"
                          background-color="white"
                          v-model="usuario.senha"
                          label="Senha"
                          maxlength="20"
                          :type="showSenha ? 'text' : 'password'"
                          :append-icon="showSenha ? 'visibility' : 'visibility_off'"
                          @click:append="showSenha = !showSenha"
                          hint="Obrigatório"
                          :rules="[validacao.senha == false || validacao.senha, (value) => !!value || 'Obrigatório.', (value) => value.length > 5 || 'Obrigatório.']"
                          @change="validacao.senha = false"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field
                          :disabled="isUpdating"
                          background-color="white"
                          v-model="confSenha"
                          label="Repetir Senha"
                          :append-icon="showSenha ? 'visibility' : 'visibility_off'"
                          @click:append="showSenha = !showSenha"
                          maxlength="20"
                          :type="showSenha ? 'text' : 'password'"
                          hint="Obrigatório"
                          :rules="[(value) => (!!value && value == usuario.senha) || 'Obrigatório.']"
                          @change="validacao.senha = false"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 v-if="$route.query.promo">
                        <v-text-field
                          :disabled="isUpdating"
                          background-color="white"
                          v-model="usuario.promocional"
                          maxlength="25"
                          label="Código Promocional"
                          :rules="[validacao.promocional == false || validacao.promocional]"
                          autocomplete="disabled"
                          :name="Math.random()"
                          @change="validacao.promocional = false"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12>
                        <v-sheet class="ml-1 green--text" :value="true" v-if="tokenValidar"><strong>Um código foi enviado para o e-mail informado</strong></v-sheet>
                      </v-flex>
                      <v-flex xs12 v-if="tokenValidar">
                        <v-text-field
                          :disabled="isUpdating"
                          background-color="white"
                          v-model="usuario.tokenEmail"
                          maxlength="25"
                          label="Informe o código recebido"
                          :rules="[validacao.tokenEmail == false || validacao.tokenEmail]"
                          autocomplete="disabled"
                          :name="Math.random()"
                          @change="validacao.tokenEmail = false"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12>
                        <v-sheet class="ml-1 red--text" :value="true" v-if="validacao.mensagemErro">{{ validacao.mensagemErro }}</v-sheet>
                      </v-flex>

                      <v-flex xs12 v-if="rodape" class="text-center">
                        <div v-html="rodape"></div>
                      </v-flex>
                      <v-flex xs12 class="text-center">
                        <v-btn :disabled="isUpdating" class="primary" large @click="novo">{{ tokenValidar ? "Validar Código" : "Criar Usuário" }}</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-tab-item>

              <v-tab-item>
                <v-form ref="formRecuperar" v-model="recuperarValid" lazy-validation class="mt-4">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field
                          autofocus
                          :disabled="isUpdating"
                          background-color="white"
                          v-model="usuario.identificacao"
                          maxlength="14"
                          v-mask="'##############'"
                          label="Informe seu CPF/CNPJ"
                          hint="Obrigatório"
                          :rules="[validacao.identificacao == false || validacao.identificacao, (value) => !!value || 'Obrigatório.', (value) => valida_identificacao(value)]"
                          autocomplete="disabled"
                          :name="Math.random()"
                          @change="validacao.identificacao = false"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-sheet class="ml-1 red--text" :value="true" v-if="validacao.mensagemErro">{{ validacao.mensagemErro }}</v-sheet>
                      </v-flex>
                      <v-flex xs12>
                        <v-sheet class="ml-1 green--text" :value="true" v-if="mensagemRecuperar">{{ mensagemRecuperar }}</v-sheet>
                      </v-flex>
                      <v-flex xs12 v-if="logar">
                        <a href="#" @click="tab = 0">Acessar</a>
                      </v-flex>
                      <v-flex xs12 class="text-center">
                        <v-btn :disabled="isUpdating || logar" class="primary" large @click="recuperar">Recuperar Senha</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-tab-item>

              <v-tab-item v-if="abaAlterar">
                <v-form ref="formAlterar" v-model="alterarValid" lazy-validation class="mt-4">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field
                          autofocus
                          :disabled="isUpdating || passo > 0"
                          background-color="white"
                          v-model="usuario.identificacao"
                          maxlength="14"
                          v-mask="'##############'"
                          label="Informe seu CPF/CNPJ"
                          hint="Obrigatório"
                          :rules="[validacao.identificacao == false || validacao.identificacao, (value) => !!value || 'Obrigatório.', (value) => valida_identificacao(value)]"
                          autocomplete="disabled"
                          :name="Math.random()"
                          @change="validacao.identificacao = false"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-if="passo == 1"
                          :disabled="isUpdating"
                          v-model="usuario.tokenWhats"
                          label="Informe o código recebido"
                          maxlength="25"
                          hint="Obrigatório"
                          :rules="[validacao.tokenWhats == false || validacao.tokenWhats, (value) => !!value || 'Obrigatório.']"
                          color="blue-grey lighten-2"
                          @change="validacao.tokenWhats = false"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-if="passo == 2"
                          :disabled="isUpdating"
                          background-color="white"
                          v-model="usuario.email"
                          maxlength="100"
                          label="Informe seu novo e-mail"
                          hint="Obrigatório"
                          :rules="[validacao.email == false || validacao.email, (value) => !!value || 'Obrigatório.', (value) => valida_email(value)]"
                          autocomplete="disabled"
                          :name="Math.random()"
                          @change="validacao.email = false"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-if="passo == 3"
                          :disabled="isUpdating"
                          background-color="white"
                          v-model="usuario.tokenEmail"
                          maxlength="25"
                          label="Informe o código recebido"
                          :rules="[validacao.tokenEmail == false || validacao.tokenEmail]"
                          autocomplete="disabled"
                          :name="Math.random()"
                          @change="validacao.tokenEmail = false"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-sheet class="ml-1 red--text" :value="true" v-if="validacao.mensagemErro">{{ validacao.mensagemErro }}</v-sheet>
                      </v-flex>
                      <v-flex xs12>
                        <v-sheet class="ml-1 green--text" :value="true" v-if="mensagemAlterar"
                          ><strong>{{ mensagemAlterar }}</strong></v-sheet
                        >
                      </v-flex>
                      <v-flex xs12 v-if="logar">
                        <a href="#" @click="tab = 0">Acessar</a>
                      </v-flex>
                      <v-flex xs12 class="text-center">
                        <v-btn :disabled="isUpdating || passo == 4" class="primary" large @click="alterar">Enviar</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>

          <v-card-actions><!--para login com facebook, quando DSM reativar o aplicativo--></v-card-actions>
        </v-card>
      </v-layout>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { api } from "@/services/api.js";
import util from "../util";
export default {
  data() {
    return {
      usuario: {
        //* entrar
        login: "",
        senha: "",
        //* novo
        identificacao: "",
        email: "",
        nome: "",
        tokenEmail: "",
        tokenWhats: "",
        dtNascimento: null,
        sexo: "N",
        celular: 0,
        comercial: 0,
        residencial: 0,
        whatsapp: 0,
        ddd: "",
        numero: "",
        senha: "",
        promocional: ""
      },
      validacao: {
        login: false,
        senha: false,
        identificacao: false,
        email: false,
        nome: false,
        tokenEmail: false,
        dtNascimento: false,
        sexo: false,
        tipoFone: false,
        ddd: false,
        numero: false,
        senha: false,
        promocional: false,
        mensagemErro: false
      },
      dtNascimento: null, //não obrigatória
      tipoFone: "WHATSAPP",
      confSenha: "",
      sexos: [
        { id: "M", nome: "Masculino" },
        { id: "F", nome: "Feminino" },
        { id: "O", nome: "Outros" },
        { id: "N", nome: "Não Informado" }
      ],
      tiposFone: [
        { id: "WHATSAPP", nome: "Whatsapp" },
        { id: "CELULAR", nome: "Celular" },
        { id: "RESIDENCIAL", nome: "Residencial" },
        { id: "COMERCIAL", nome: "Comercial" }
      ],

      abaAlterar: false,
      recSenha: false,
      showSenha: false,
      entrarValid: true,
      novoValid: true,
      recuperarValid: true,
      tokenValidar: false,
      mensagemRecuperar: "",
      logar: false,
      alterarValid: true,
      passo: 0,
      mensagemAlterar: "",

      isUpdating: false,
      logotipo: "x",
      rodape: "",
      tab: null
    };
  },

  methods: {
    async entrar() {
      this.isUpdating = true;
      try {
        await util.limparObjeto(this.validacao, false);

        if (!this.$refs.formEntrar.validate()) {
          this.validacao.mensagemErro = "Verifique os campos indicados em vermelho no formulário";
          return;
        }

        //* Define os dados a serem enviados
        var body = {
          login: this.usuario.login,
          senha: this.usuario.senha,
          redirect_uri: this.$route.query.redirect_uri
        };

        //* Busca o tokenAuth
        var response = await api.loginAuth(body);

        // if (this.$route.query.redirect_uri) {
        //REDIRECIONAR SOMENTE APÓS REGISTRAR O TOKEN NO PAYWALL (PARA FICAR SEMPRE AUTENTICADO)
        //* Se é requisição de parceiro, redirecionar para o site dele, passando o response.data.token
        //exemplo: urlPaywall/login?redirect_uri=http://delivery.com.br/oauth/redirect?state=stringRandomica
        //direcionar para:                       http://delivery.com.br/oauth/redirect?state=stringRandomica&code=   response.data.token
        //   this.redirecionaUsuario(response.data.token);
        //   return;
        // }

        //* Busca o ip local do usuário
        var ip = { ip: "" };

        try {
          const responseIP = await axios.get("https://ipinfo.io/ip");
          ip = { ip: responseIP.data };
        } catch (e) {
          console.log(e);
        }

        //* Busca o tokenAccess - parceiros só irá executar a partir daqui (sem o codigo promocional) - pois já receberam o tokenAuth na requisição
        body = {
          client_id: response.data.sigla + response.data.idSite,
          client_secret: "SuitaSIM",
          code: response.data.token,
          promocional: this.usuario.promocional,
          ip: ip.ip
        };

        var retorno = await api.login(body);

        //* Armazena os dados para acesso externo (por javascript)
        localStorage.setItem("pwK", `${retorno.data.sessao.token}`);

        await this.$store.dispatch("getUsuario"); //busca e coloca os dados do usuário na sessão

        //* Redireciona o usuario para a pagina correta - aguarda 3 segundos para garantir que o pwU foi registrado
        setTimeout(() => {
          this.redirecionaUsuario(retorno.data.sessao.token);
          this.isUpdating = false;
        }, 3000);
      } catch (e) {
        if (e.toString().includes("status code 400")) {
          this.validacao.mensagemErro = "SESSÃO EXPIRADA";
        } else if (e.response && e.response.data) {
          util.validaErros(this.validacao, e.response.data);
          this.recSenha = true;
        } else {
          this.validacao.mensagemErro = "Ocorreu um erro indeterminado, verifique sua conexão";
        }
        this.isUpdating = false;
      }
    },

    async novo() {
      this.isUpdating = true;
      try {
        await util.limparObjeto(this.validacao, false);

        if (!this.$refs.formNovo.validate()) {
          this.validacao.mensagemErro = "Verifique os campos indicados em vermelho no formulário";
          return;
        }

        if (this.tipoFone == "CELULAR") {
          this.usuario.celular = 1;
        } else if (this.tipoFone == "RESIDENCIAL") {
          this.usuario.residencial = 1;
        } else if (this.tipoFone == "COMERCIAL") {
          this.usuario.comercial = 1;
        } else {
          this.usuario.celular = 1;
          this.usuario.whatsapp = 1;
        }

        //* Busca o ip local do usuário
        var ip = { ip: "" };

        try {
          const responseIP = await axios.get("https://ipinfo.io/ip");
          ip = { ip: responseIP.data };
        } catch (e) {
          console.log(e);
        }

        //* Define os dados a serem enviados
        var body = {
          identificacao: this.usuario.identificacao,
          email: this.usuario.email,
          nome: this.usuario.nome,
          tokenEmail: this.usuario.tokenEmail,
          senha: this.usuario.senha,
          dtNascimento: util.formatDateUS(this.dtNascimento),
          sexo: this.usuario.sexo,
          celular: this.usuario.celular,
          residencial: this.usuario.residencial,
          comercial: this.usuario.comercial,
          whatsapp: this.usuario.whatsapp,
          ddd: this.usuario.ddd,
          numero: this.usuario.numero,
          senha: this.usuario.senha,
          promocional: this.usuario.promocional,
          redirect_uri: this.$route.query.redirect_uri,
          ip: ip.ip
        };

        //* Salva o novo usuário
        var response = await api.post("/ass/paywall/usuario", body);

        // if (this.$route.query.redirect_uri) {
        //   //* Se é requisição de parceiro, redirecionar para o site dele, passando o response.data.token
        //   //exemplo: urlPaywall/login?redirect_uri=http://delivery.com.br?state=stringRandomica
        //   //direcionar para:                       http://delivery.com.br?state=stringRandomica&code=   response.data.token
        //   this.redirecionaUsuario(response.data.tokenAuth);
        //   return;
        // }

        //* Armazena os dados para acesso externo (por javascript)
        localStorage.setItem("pwK", `${response.data.sessao.token}`);

        await this.$store.dispatch("postUsuario", response.data.sessao); //coloca os dados do usuário na sessão

        setTimeout(() => {
          //* Redireciona o usuario para a pagina correta
          this.redirecionaUsuario(response.data.sessao.token);
        }, 1000);
      } catch (e) {
        if (e.toString().includes("status code 400")) {
          this.validacao.mensagemErro = "SESSÃO EXPIRADA";
        } else if (e.response && e.response.data) {
          if (e.response.data.tipo == "tokenEmail") {
            this.tokenValidar = true;
          } else if (e.response.data.duplicado) {
            util.validaErros(this.validacao, e.response.data.erros);
            this.recSenha = true;
          } else {
            util.validaErros(this.validacao, e.response.data.erros);
          }
        } else {
          this.validacao.mensagemErro = "Ocorreu um erro indeterminado, verifique sua conexão";
        }
      } finally {
        this.isUpdating = false;
      }
    },

    async recuperar() {
      this.isUpdating = true;
      try {
        await util.limparObjeto(this.validacao, false);

        if (!this.$refs.formRecuperar.validate()) {
          this.validacao.mensagemErro = "Verifique os campos indicados em vermelho no formulário";
          return;
        }

        this.mensagemRecuperar = "Enviando uma nova senha ...";

        //* Define os dados a serem enviados
        var body = {
          identificacao: this.usuario.identificacao
        };

        const retorno = await api.put("/ass/paywall/recuperar-senha", body);

        //* mostra email parcial, senão qualquer um com um cpf obteria o e-mail do cliente
        var partes = retorno.data.email.split("@");
        var emailRet = partes[0].substr(0, 2) + "***@";
        emailRet += partes[1];
        this.mensagemRecuperar = "Uma nova senha foi enviada para o e-mail " + emailRet;
        this.logar = true;
      } catch (e) {
        if (e.toString().includes("status code 400")) {
          this.validacao.mensagemErro = "SESSÃO EXPIRADA";
        } else if (e.response && e.response.data) {
          util.validaErros(this.validacao, e.response.data);
        } else {
          this.validacao.mensagemErro = "Ocorreu um erro indeterminado, verifique sua conexão";
        }
      } finally {
        this.isUpdating = false;
      }
    },

    async alterar() {
      this.isUpdating = true;
      try {
        await util.limparObjeto(this.validacao, false);

        this.mensagemAlterar = "";

        if (!this.$refs.formAlterar.validate()) {
          this.validacao.mensagemErro = "Verifique os campos indicados em vermelho no formulário";
          return;
        }

        if (this.passo == 0) {
          //* Define os dados a serem enviados
          var body = {
            identificacao: this.usuario.identificacao
          };

          const retorno = await api.put("/ass/paywall/alterar-email", body);
          this.mensagemAlterar =
            "Um código foi enviado para seu Whatsapp " + retorno.data.whatsapp.substring(2, 4) + "***" + retorno.data.whatsapp.substr(retorno.data.whatsapp.length - 4);
          this.passo = 1;
        } else if (this.passo == 1) {
          //* Define os dados a serem enviados
          var body = {
            identificacao: this.usuario.identificacao,
            tokenWhats: this.usuario.tokenWhats
          };

          await api.put("/ass/paywall/alterar-email", body);
          this.mensagemAlterar = "Código validado com sucesso";
          this.passo = 2;
        } else if (this.passo == 2) {
          //* Define os dados a serem enviados
          var body = {
            identificacao: this.usuario.identificacao,
            tokenWhats: this.usuario.tokenWhats,
            email: this.usuario.email
          };

          await api.put("/ass/paywall/alterar-email", body);
          this.mensagemAlterar = "Um código foi enviado para o e-mail informado";
          this.passo = 3;
        } else if (this.passo == 3) {
          //* Define os dados a serem enviados
          var body = {
            identificacao: this.usuario.identificacao,
            email: this.usuario.email,
            tokenEmail: this.usuario.tokenEmail
          };

          await api.put("/ass/paywall/alterar-email", body);
          this.mensagemAlterar = "Código validado com sucesso! Seus dados de acesso foram enviados para seu novo e-mail.";
          this.passo = 4;
          this.logar = true;
        }
      } catch (e) {
        if (e.toString().includes("status code 400")) {
          this.validacao.mensagemErro = "SESSÃO EXPIRADA";
        } else if (e.response && e.response.data) {
          util.validaErros(this.validacao, e.response.data);
        } else {
          this.validacao.mensagemErro = "Ocorreu um erro indeterminado, verifique sua conexão";
        }
      } finally {
        this.isUpdating = false;
      }
    },

    redirecionaUsuario(token) {
      //* Verifica se foi definida uma url de redirecionamento
      if (this.$route.query.url) {
        //* Redireciona para a url (matéria) solicitada
        window.location = this.$route.query.url;
      } else if (this.$route.query.redirect && this.$route.query.redirect != "/alterar-senha") {
        //* Redirecionamento interno
        this.$router.push(this.$route.query.redirect);
        if (this.$store.state.site.redirect_uri) {
          this.$router.go(this.$route.query.redirect);
        }
      } else if (this.$route.query.redirect_uri) {
        //* Redirecionamento para o parceiro
        window.location = this.$route.query.redirect_uri + "&code=" + token;
      } else if (this.usuario.promocional) {
        //* Se logou com código promocional (não direcionado de um plano), vai para a tela assine
        this.$router.push("/assine");
        if (this.$store.state.site.redirect_uri) {
          this.$router.go("/assine");
        }
      } else if (this.$store.state.usuario.idDependente) {
        if (this.$store.state.site.flip) {
          this.$router.push("/newflip");
          if (this.$store.state.site.redirect_uri) {
            this.$router.go("/newflip");
          }
        } else {
          this.$router.push("/alterar-senha");
          if (this.$store.state.site.redirect_uri) {
            this.$router.go("/alterar-senha");
          }
        }
      } else {
        //* Se não entrou a partir do assine, vai para "minhas assinaturas"
        this.$router.push("/assinaturas");
        if (this.$store.state.site.redirect_uri) {
          this.$router.go("/assinaturas");
        }
      }
    },
    assine() {
      this.$router.push("/assine");
    },

    valida_email_identificacao(text) {
      if (!util.valida_email(text)) {
        //* Caso o cliente não possua e-mail, permite entrar com a identificação para não quebrar a chave única
        if (text != util.somenteNumeros(text) || (!util.valida_cpf(text) && !util.valida_cnpj(text))) {
          return "E-mail/Identificação inválida";
        }
      }
      return true;
    },
    valida_identificacao(text) {
      if (text != util.somenteNumeros(text) || (!util.valida_cpf(text) && !util.valida_cnpj(text))) {
        return "Identificação inválida";
      }
      return true;
    },
    valida_email(text) {
      if (!util.valida_email(text)) {
        return "E-mail inválido";
      }
      return true;
    },
    valida_data_nasc(date) {
      if (!util.valida_data_nasc_BR(date)) {
        return "Data de nascimento inválida";
      }
      return true;
    },
    valida_ddd(text) {
      if (!util.isDDDvalido(text)) {
        return "DDD inválido";
      }
      return true;
    },

    pLetra(text) {
      text = util.removeSomenteEspeciais(text);
      return util.pLetra(text);
    },
    filtrarObjetos(item, queryText, itemText) {
      return util.filtrarObjetos(item, queryText, itemText);
    }
  },
  watch: {
    tab() {
      util.limparObjeto(this.validacao, false);
    }
  },
  async beforeMount() {
    do {
      await util.delay(1000);
    } while (!this.$store.state.site.enderecoSite);

    if (this.$store.state.site.enderecoSite) {
      this.rodape = this.$store.state.site.rodape;
      var urlApi = (window.location.host.includes("localhost") ? "http://localhost:3000" : "") + "/api/";
      this.logotipo = `${urlApi}arquivos/${this.$store.state.site.id}/logo.png`;
      this.abaAlterar = this.$store.state.site.takeBlipKey ? true : false;
      if (!this.$store.state.site.paywall && !this.$store.state.site.assinante && (!this.$store.state.site.flip || this.$store.state.site.flipPublico)) {
        this.$router.push("/assine");
      }
      document.title = this.$store.state.site.nome;
    } else {
      this.logotipo = "";
    }

    if (this.$route.query.promo || this.$route.query.tab == 1) {
      this.tab = 1;
    }
  }
};
</script>
